@if (status === 1) {
  <div class="zwi-main-content">
    <zwi-widget>
      <div>Loading</div>
    </zwi-widget>
  </div>
} @else {
  @if (searchLoaded()) {
    @if (ministries.length > 0) {
      <zwi-ministry-list [followable]="authService.hasSession()" [ministries]="ministries" (subscribeChange)="changeSubscription($event)"></zwi-ministry-list>
    } @else {
      <zwi-widget>No results containing your search terms were found.</zwi-widget>
    }
  } @else {
    <zwi-widget>Search for ministries</zwi-widget>
  }
}
